import React from 'react';
import { useTranslation } from 'react-i18next';
import colors from '../../../../theme/colors';
import { NowTabIcon } from '@mafc/icon';
import { Box } from '@mafc/trolly';
import * as S from './NowOffLineHours.style';
import { useMount } from '@mafc/hooks';
import { smartlook } from '@mafc/appshell';
import { smartlookErrorLabels } from '@mafc/common';

const NowOffLineHours: React.FC<{
  busyHourDisclaimer: string;
  nextAvailableSlot: any;
  isMobile?: boolean;
  isNowOfflineHour: boolean;
}> = ({ nextAvailableSlot = {}, isNowOfflineHour, busyHourDisclaimer, isMobile = false }) => {
  const { t } = useTranslation();
  const offlineMessage = t('offlineHeadingMessage');

  useMount(() => {
    smartlook.track(smartlookErrorLabels.nowClosed);
  });
  return offlineMessage ? (
    <S.Container isMobile={isMobile}>
      <NowTabIcon size="custom" width="24px" fill={colors.ERROR_RED} />
      <Box>
        <S.NowMessage>
          {isNowOfflineHour ? (
            <>
              <Box as="span">{`${t('offlineHeadingMessage')} `}</Box>
              <Box as="span" sx={{ fontWeight: 'bold' }}>
                {nextAvailableSlot.day}{' '}
                {nextAvailableSlot.startTime ? nextAvailableSlot.startTime.toUpperCase() : ''}
              </Box>
            </>
          ) : (
            <Box>{busyHourDisclaimer}</Box>
          )}
        </S.NowMessage>
      </Box>
    </S.Container>
  ) : (
    <></>
  );
};

export default NowOffLineHours;
